import styles from './programme-info-pill.module.scss'

export const ProgrammeInfoPill = ({ text }: { text: string }): React.ReactElement => {
  return (
    <div className={styles.programmeInfoPill}>
      <p className={styles.programmeInfoPillText}>{text}</p>
    </div>
  )
}
